@let displayedLines = displayedLines$ | async;
@if (displayedLines?.length && !tooManyColumns) {
    <ui-table class="medium-margin" layoutType="dynamic" [dataSource]="displayedLines">
        @for (column of orderedColumnDimensionCodes$ | async; track column) {
            <ng-container [uiColumnDef]="column" [alignment]="formattingInformation[column]?.columnAlignment">
                <ui-header-cell *uiHeaderCellDef>{{ formattingInformation[column].headerName }}</ui-header-cell>
                <ui-cell *uiCellDef="let line">{{ line[column] | async }}</ui-cell>
            </ng-container>
        }
        @for (id of pivotGeneratedColumns$ | async; track id) {
            <ng-container [uiColumnDef]="id" [alignment]="formattingPivotCells$ | async">
                <ui-header-cell *uiHeaderCellDef>
                    {{ ((pivotGeneratedColumnsHeaderNames$ | async) || {})[id] }}
                </ui-header-cell>
                <ui-cell *uiCellDef="let line">{{ line[id] | async }}</ui-cell>
            </ng-container>
        }
        <ui-header-row *uiHeaderRowDef="allColumns$ | async" />
        <ui-row *uiRowDef="let row; columns: allColumns$ | async" />
    </ui-table>
}
@if (displayedLines?.length && !tooManyColumns) {
    <shared-ui-paginator
        [elementCount]="totalElements"
        [page]="paginationParams$.getValue().page"
        [pageSize]="paginationParams$.getValue().pageSize"
        (paginationParamsChange)="setPagination($event)"
    />
} @else {
    <loading-and-error
        class="no-data"
        errorMessage="TAILORED_WIDGET.BUSINESS_INTELLIGENCE.PIVOT_TABLE.TOO_MANY_COLUMNS"
        [hasNoData]="!displayedLines?.length"
        [hasError]="tooManyColumns"
    />
}
